/**
 * Small auth-aware text link. Renders "Log in" if anonymous,
 * "My Account" with a tiny user glyph if authenticated. Used in the
 * homepage header, footer, and mobile sticky bar so customers can
 * reach the auth/account screens from anywhere.
 */
import { Link } from "react-router-dom";
import { User } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const AccountLink = ({ className = "", testIdPrefix = "account-link" }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user) {
    return (
      <Link
        to="/account"
        className={`inline-flex items-center gap-1.5 text-sm text-[#6B6B6B] hover:text-[#1A1A1A] ${className}`}
        data-testid={`${testIdPrefix}-account`}
      >
        <User size={16} strokeWidth={1.6} />
        My Account
      </Link>
    );
  }

  return (
    <Link
      to="/login"
      className={`inline-flex items-center gap-1.5 text-sm text-[#6B6B6B] hover:text-[#1A1A1A] ${className}`}
      data-testid={`${testIdPrefix}-login`}
    >
      <User size={16} strokeWidth={1.6} />
      Log in
    </Link>
  );
};

export default AccountLink;
